import React from 'react';
import Button from '../components/elements/Button';

// Copy Helper
const copyToClipboard = (text) => {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
            alert(`「${text}」をコピーしました`);
        }).catch(err => {
            console.error('Copy failed', err);
        });
    } else {
        // Fallback for older browsers if needed
        alert("このブラウザではコピー機能がサポートされていません");
    }
};

const InvoiceView = () => {

    // Mock Invoice Data
    const invoiceData = {
        invoiceNumber: 'INV-202310-001',
        issueDate: '2023年10月01日',
        dueDate: '2023年10月31日',
        amount: '¥55,000', // incl tax
        billingTo: '株式会社サンプル 様',

        // Bank Info
        bankName: 'GMOあおぞらネット銀行',
        branchName: '法人営業部', // branch code usually needed?
        accountType: '普通',
        accountNumber: '1234567',
        accountName: 'PITHIAS Technologies合同会社',
        accountNameKana: 'ピシアステクノロジーズゴウドウガイシャ'
    };

    const styles = {
        container: {
            maxWidth: '800px',
            margin: '40px auto',
            padding: '40px',
            backgroundColor: '#fff',
            color: '#333',
            fontFamily: '"Helvetica Neue", Arial, sans-serif',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            borderRadius: '8px'
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '2px solid #eee',
            paddingBottom: '20px',
            marginBottom: '30px'
        },
        title: {
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#1f63d6'
        },
        meta: {
            textAlign: 'right',
            fontSize: '14px',
            lineHeight: '1.6'
        },
        billingInfo: {
            marginBottom: '40px',
            fontSize: '18px'
        },
        amountBox: {
            background: '#f9f9f9',
            padding: '20px',
            borderRadius: '4px',
            textAlign: 'center',
            marginBottom: '40px'
        },
        amountLabel: {
            fontSize: '14px',
            color: '#666',
            marginBottom: '8px'
        },
        amountValue: {
            fontSize: '32px',
            fontWeight: 'bold',
            color: '#333'
        },
        bankSection: {
            border: '1px solid #ddd',
            padding: '24px',
            borderRadius: '4px',
            backgroundColor: '#fff'
        },
        bankTitle: {
            fontSize: '16px',
            fontWeight: 'bold',
            marginBottom: '16px',
            borderBottom: '1px solid #eee',
            paddingBottom: '8px'
        },
        row: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '12px',
            flexWrap: 'wrap'
        },
        label: {
            width: '120px',
            fontWeight: 'bold',
            color: '#555',
            fontSize: '14px'
        },
        value: {
            flex: 1,
            fontSize: '16px',
            marginRight: '12px'
        },
        copyBtn: {
            fontSize: '12px',
            padding: '4px 8px',
            cursor: 'pointer',
            backgroundColor: '#f0f0f0',
            border: '1px solid #ccc',
            borderRadius: '4px'
        }
    };

    return (
        <div className="invoice-view-page" style={{ backgroundColor: '#f4f4f4', minHeight: '100vh', padding: '20px' }}>
            <div className="invoice-view-card" style={styles.container}>

                {/* Header */}
                <div className="invoice-view-header" style={styles.header}>
                    <div style={styles.title}>御請求書</div>
                    <div style={styles.meta}>
                        登録番号: T1234567890123 (仮)<br />
                        請求書番号: {invoiceData.invoiceNumber}<br />
                        発行日: {invoiceData.issueDate}<br />
                        支払期限: {invoiceData.dueDate}
                    </div>
                </div>

                {/* Billed To */}
                <div style={styles.billingInfo}>
                    {invoiceData.billingTo}
                </div>

                {/* Total Amount */}
                <div style={styles.amountBox}>
                    <div style={styles.amountLabel}>ご請求金額（税込）</div>
                    <div style={styles.amountValue}>{invoiceData.amount}</div>
                </div>

                {/* Transfer Info */}
                <div className="invoice-view-bank-section" style={styles.bankSection}>
                    <div style={styles.bankTitle}>お振込先情報</div>

                    <div className="invoice-view-row" style={styles.row}>
                        <div style={styles.label}>金融機関</div>
                        <div style={styles.value}>{invoiceData.bankName}</div>
                        <button style={styles.copyBtn} onClick={() => copyToClipboard(invoiceData.bankName)}>コピー</button>
                    </div>

                    <div className="invoice-view-row" style={styles.row}>
                        <div style={styles.label}>支店名</div>
                        <div style={styles.value}>{invoiceData.branchName}</div>
                        <button style={styles.copyBtn} onClick={() => copyToClipboard(invoiceData.branchName)}>コピー</button>
                    </div>

                    <div className="invoice-view-row" style={styles.row}>
                        <div style={styles.label}>口座種別</div>
                        <div style={styles.value}>{invoiceData.accountType}</div>
                    </div>

                    <div className="invoice-view-row" style={styles.row}>
                        <div style={styles.label}>口座番号</div>
                        <div style={styles.value}>{invoiceData.accountNumber}</div>
                        <button style={styles.copyBtn} onClick={() => copyToClipboard(invoiceData.accountNumber)}>コピー</button>
                    </div>

                    <div className="invoice-view-row" style={styles.row}>
                        <div style={styles.label}>口座名義</div>
                        <div style={styles.value}>{invoiceData.accountName}</div>
                        <button style={styles.copyBtn} onClick={() => copyToClipboard(invoiceData.accountName)}>コピー</button>
                    </div>

                    <div className="invoice-view-row" style={styles.row}>
                        <div style={styles.label}>口座名義（カナ）</div>
                        <div style={styles.value}>{invoiceData.accountNameKana}</div>
                        <button style={styles.copyBtn} onClick={() => copyToClipboard(invoiceData.accountNameKana)}>コピー</button>
                    </div>
                </div>

                <div style={{ marginTop: '40px', textAlign: 'center' }}>
                    <div style={{ fontSize: '12px', color: '#999', marginBottom: '16px' }}>
                        ※振込手数料は貴社負担にてお願いいたします。<br />
                        ※支払期限当日に銀行の営業時間外にお振込みいただいた場合、翌営業日の入金扱いとなり、期限を過ぎることがあります。
                    </div>
                    <Button color="primary" onClick={() => window.print()}>このページを印刷</Button>
                </div>

            </div>
        </div>
    );
};

export default InvoiceView;
